import React from 'react'

import {
  BuildVersionChecker,
  Client,
  FeatureFlagsProvider,
  GoneFishin,
  ReactQueryClientProvider,
  Toaster,
  initializeSentry,
} from '@termly-web/common'

import fetchHealth from 'utils/fetchHealth'

import DashboardIntlProvider from 'components/DashboardIntlProvider'

import Router from './Router'

import endIframeSessionOn401 from './lib/endIframeSessionOn401'

import './styles.scss'


const FLAGSMITH_ENVIRONMENT_ID = process.env.FLAGSMITH_ENVIRONMENT_ID

initializeSentry()

// Registered here rather than in the shared client, because some of the other
// applications built on that client are embedded in iframes too, and in them a
// refusal with no bearer token held does not mean a session has ended.
Client.interceptors.response.use(null, endIframeSessionOn401)


export default function App() {
  const preferredLocales = window.navigator.languages

  return (
    <FeatureFlagsProvider
      environmentID={ FLAGSMITH_ENVIRONMENT_ID }
    >
      <ReactQueryClientProvider>
        <DashboardIntlProvider
          preferredLocales={ preferredLocales }
        >
          <BuildVersionChecker />
          <GoneFishin
            fetchHealth={ fetchHealth }
          >
            <Router />
          </GoneFishin>
          <Toaster />
        </DashboardIntlProvider>
      </ReactQueryClientProvider>
    </FeatureFlagsProvider>
  )
}
